import { LOGOUT, SET_ASSESSMENT_DATA } from "../actions/action.types";

const initialState = {
  assessmentList: [],
};

const assessmentReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ASSESSMENT_DATA:
      return { ...state, assessmentList: payload };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default assessmentReducer;
